import DataTable from "react-data-table-component";
import { CircularProgress } from "@mui/material";
import { conditionalRowStyles, customStyles } from "../css/datatableStyle";
import { useCallback, useEffect, useMemo, useState } from "react";
// import ParamContext from "../contexts/paramContext";
import React from "react";
import { NoDataComponent, NotAllowedComponent } from "../js/components";
import axios from "axios";

import "../css/global.css";
//add new props setRow
const DTable = React.memo(
  ({
    dataset,
    columns,
    filter,
    api,
    service,
    customStylesSet,
    setDoSearch,
    reset,
    setReset,
    paginationRowsPerPageOptions,
    conditionalRowStylesSet,
    expandableRows,
    expandableRowExpanded,
    expandableRowsComponent,
    fixedHeader,
    fixedHeaderScrollHeight,
    title,
    noHeader,
    persistTableHead,
    onRowClicked,
    selectableRows,
    selectableRowsVisibleOnly,
    setSelectedRows,
    selectableRowDisabled,
    cellHeight,
    CustomCheckbox,
    callback,
    defaultPerPage,
    headerHeight,
  }) => {
    // const param = useContext(ParamContext);
    const Gfunc = require("../Gfunc");
    const librery = require("../js/data_table_librery");
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    // eslint-disable-next-line
    const [noData, setNoData] = useState(false);
    const [notAllowed, setNotAllowed] = useState(false);
    const [errMessage, setErrMessage] = useState("");
    // eslint-disable-next-line
    const [records, setRecords] = useState("");
    const [resetDP, setResetDP] = useState(false); // Initialize resetDP to true
    const [called, setCalled] = useState(true); // Initialize resetDP to true
    const [
      paginationRowsPerPageOptionsDefault,
      setPaginationRowsPerPageOptionsDefault,
    ] = useState(paginationRowsPerPageOptions ?? [15, 25, 50, 75, 100]); // Initialize resetDP to true
    const defPerPage = defaultPerPage ? defaultPerPage : 15;

    //const [divHeight, setDivHeight] = useState(0);

    // const getPerPage = useCallback(() => {

    //   if (cellHeight) {
    //     const targetDiv = document.getElementById('main-content');
    //     if (targetDiv) {
    //       const height = targetDiv.clientHeight;
    //       let nbr = Math.floor((height - 260) / cellHeight);
    //       console.log(cellHeight)
    //       console.log(height)
    //       console.log(nbr)
    //       // Ensure nbr is a multiple of 5
    //       //nbr = nbr - (nbr % 5);

    //       // Check if the new nbr already exists to avoid unnecessary updates
    //       if (!paginationRowsPerPageOptionsDefault.includes(nbr)) {
    //         let po = [...paginationRowsPerPageOptionsDefault, nbr].sort((a, b) => a - b);
    //         setPerPage(nbr);
    //         setPaginationRowsPerPageOptionsDefault(po);
    //       } else {
    //         // If the per page is different, update it
    //         if (nbr !== perPage) {
    //           setPerPage(nbr);
    //         }
    //       }
    //     }
    //   }
    // }, [cellHeight, paginationRowsPerPageOptionsDefault, perPage]);

    const getPerPage = useCallback(() => {
      if (cellHeight) {
        const targetDiv = document.getElementById("main-content");
        
        if (targetDiv) {
            
          //const height = 800;
          const height = targetDiv.clientHeight;
          let nbr = Math.floor((height - (headerHeight ?? 172)) / cellHeight);
          // Ensure nbr is a multiple of 5
          // nbr = nbr - (nbr % 5);
          if (nbr >= defPerPage) {
            // Check if the new nbr already exists to avoid unnecessary updates
            if (!paginationRowsPerPageOptionsDefault.includes(nbr)) {
              let po = [...paginationRowsPerPageOptionsDefault, nbr].sort(
                (a, b) => a - b
              );
              setPerPage(nbr);
              setPaginationRowsPerPageOptionsDefault(po);
            } else {
              // If the per page is different, update it
              if (nbr !== perPage) {
                setPerPage(nbr);
              }
            }
          } else setPerPage(defPerPage);
        }
      } else setPerPage(defPerPage);
      setCalled(false);
    }, [cellHeight, paginationRowsPerPageOptionsDefault, perPage]);

    const [cancelTokenSource, setCancelTokenSource] = useState(null);
    const fetch = useCallback(
      async (page = currentPage, rowsPerPage = perPage) => {
        if (rowsPerPage) {
          setLoading(true);
          setData([]);
          setCalled(true);
          if (cancelTokenSource) {
            // If there is a previous request, cancel it
            cancelTokenSource.cancel("New request initiated");
          }
          const source = axios.CancelToken.source(); // Create a new cancel token source
          setCancelTokenSource(source); // Store the cancel token source in state

          try {
            const response = await librery.axiosGetV2(
              page,
              api,
              service ?? "get",
              rowsPerPage + (filter ?? ""),
              {
                cancelToken: source.token,
                headers: Gfunc.getHeader(),
              }
            );
            if (response.data.err && response.data.err !== "-1") {
              setErrMessage(response.data.err);
              setNotAllowed(true);
              setData([]);
            } else {
              Gfunc.axiosResponse(response, () => {
                setRecords(response.data.recordsFiltered);
                if (callback) callback(response.data);

                if (response.data.data !== undefined) {
                  setData(response?.data?.data);
                  setTotalRows(response.data.recordsFiltered);
                  setNoData(true);
                  setDoSearch(true);
                }
                if (response.data.data === undefined) {
                  setData([]);
                  setTotalRows(response.data.recordsFiltered);
                }
              });
            }
          } catch (error) {
            if (axios.isCancel(error)) {
              console.log("Request canceled", error.message);
            } else {
              // Handle other errors
            }
          }
          setLoading(false);
        }
      },
      [
        librery,
        Gfunc,
        filter,
        api,
        service,
        cancelTokenSource,
        currentPage,
        perPage,
      ]
    );
    /************************************** */
    // const [tooltipData, setTooltipData] = useState(null);
    // const handleMouseEnter = (row) => {
    //   setTooltipData(row);
    // };

    // const handleMouseLeave = () => {
    //   setTooltipData(null);
    // };
    /***************************************** */
    const handleOnSort = async (column, sortdirection) => {
      setLoading(true);
      const response = await librery.axiosSort(
        column,
        sortdirection,
        currentPage,
        perPage + filter,
        api,
        service ?? "get"
      );
      if (response.data.err && response.data.err !== "-1") {
        alert("error: "+response.data.err);
      } else {
        Gfunc.axiosResponse(response, () => {
          setData(response.data.data);
          setTotalRows(response.data.recordsFiltered);
          setLoading(false);
        });
      }
    };
    useEffect(() => {
      handleFilter();
      // eslint-disable-next-line
    }, [filter]);

    const handleFilter = useCallback(() => {
      if (currentPage === 1 && called) fetch();
      else setResetDP(!resetDP);
    }, [currentPage, fetch, called]);

    useEffect(() => {
      getPerPage();
    }, []);

    useEffect(() => {
      if (!called) {

        setCalled(true);
        fetch();
      }
    }, [called]);

    useEffect(() => {
      if (reset) {
        //reset is sent from the parent so child detect a reset to fetch the data from page 1
        if (currentPage === 1) {
          setCurrentPage(1);
          fetch();
        } // incase the current page is 1 data table doesn't reset the data so we have to do that manualy by calling fetch
        else setResetDP(!resetDP);
        setReset(false); // we must reset the parent's state to false since the reset has been applied
      }
    }, [resetDP, reset, setReset, currentPage, fetch]);

    const CustomLoader = () => (
      <div style={{ padding: "24px" }}>
        <CircularProgress style={{ marginLeft: "30px" }} />
        <div>Chargement...</div>
      </div>
    );

    function handlePageChange(page) {
      setCurrentPage(page);
      setCalled(false);
    }

    const handlePerRowsChange = async (newPerPage, page) => {
      setPerPage(newPerPage);
      setCalled(false);
    };
    /*************************************/
    const [selectedRow, setSelectedRow] = useState(null); // State to store selected rows
    const handleRowClicked = (row) => {
      setSelectedRow(row);
    };
    /*************************************/
    // const handleClickAway = () => {
    //   setSelectedRow(null);
    // }
    const handleExpandToggle = (e, row) => {
      setSelectedRow(row);
    };

    //*************** */
    const handleRowSelected = ({ selectedRows }) => {
      if (setSelectedRows)
        setSelectedRows(
          selectedRows.filter((row) => row.stats === 5 && row.auto)
        ); // Update the selected rows state
    };
    const handleSelectedRowsChange = (state) => {
      // Vérifiez si l'état a des lignes sélectionnées
      const filteredRows = state.selectedRows.filter(
        (row) => !selectableRowDisabled(row)
      );
      setSelectedRows(filteredRows);
    };

    const memoizedSelectableRowSelected = useMemo(
      () => (row) => row === selectedRow,
      [selectedRow]
    );

    /**************** */
    return data.length >= 0 && perPage && !notAllowed ? (
      <DataTable
        persistTableHead={persistTableHead}
        title={title}
        fixedHeader={fixedHeader}
        fixedHeaderScrollHeight={
          fixedHeaderScrollHeight ?? "calc(100vh - 195px)"
        }
        columns={columns}
        data={data}
        noTableHead={!noHeader ? false : true}
        noDataComponent={<NoDataComponent message="Aucun résultat trouvé" />}
        paginationRowsPerPageOptions={paginationRowsPerPageOptionsDefault}
        paginationPerPage={perPage}
        progressPending={loading}
        pagination
        paginationServer
        paginationTotalRows={totalRows}
        paginationDefaultPage={1}
        paginationResetDefaultPage={resetDP}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
        sortServer={true}
        onSort={handleOnSort}
        //******************************* */
        rowSelection={"single"}
        onRowClicked={handleRowClicked}
        // selectableRowSelected={(row) => selectedRows.some(selectedRow => selectedRow.id === row.id)}

        pointerOnHover
        highlightOnHover
        selectableRowsHighlight
        //******************************* */
        customStyles={customStylesSet ?? customStyles}
        conditionalRowStyles={conditionalRowStylesSet ?? conditionalRowStyles}
        paginationComponentOptions={{
          rowsPerPageText: "Élément par page:",
          rangeSeparatorText: "sur",
          selectAllRowsItem: true,
          selectAllRowsItemText: "Tous",
        }}
        contextMessage={{
          singular: "élément sélectionné",
          plural: "éléments sélectionnés",
        }}
        progressComponent={<CustomLoader />}
        expandableRows={expandableRows}
        expandableRowsComponent={expandableRowsComponent}
        //onRowClicked={onRowClicked}

        expandableRowExpanded={expandableRowExpanded}
        /*********************************** */
        onRowExpandToggled={handleExpandToggle}
        expandableInheritConditionalStyles={true}
        // expandOnRowClicked
        /************************************ */
        // onRowMouseEnter={handleMouseEnter}
        // onRowMouseLeave={handleMouseLeave}
        /*********************************** */
        responsive={true}
        dense
        // /********  selected multiple column */
        selectableRowSelected={memoizedSelectableRowSelected}
        selectableRows={selectableRows ? selectableRows : false}
        // selectableRowsVisibleOnly={selectableRowsVisibleOnly}
        selectableRowsComponent={CustomCheckbox}
        selectableRowsComponentProps={{ inkDisabled: true }} // optionally, pass Material Ui supported props down to our custom checkbox
        onSelectedRowsChange={handleRowSelected} // gérer les lignes sélectionnées
        selectableRowDisabled={selectableRowDisabled}
        selectableRowsVisibleOnly
      />
    ) : notAllowed ? (
      <NotAllowedComponent message={errMessage} />
    ) : null;
  }
);

export default React.memo(DTable);
